import { checkVerify, onChangeAuth, resendCodeAction } from "page/auth/redux"
import { useRedux } from "redux/useRedux"

import { Form, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from 'contexts/auth-context';
import { useContext, useState } from 'react';


const OtpLogic = () => {
    const navigate = useNavigate()
    const [formOtp] = Form.useForm()
   
    const ctx = useContext(AuthContext);
    const { dispatch, authState } = useRedux()

    async function finish(code,fromPage) {
        if(fromPage==="login"){
            const result = await dispatch(checkVerify(authState.phone,code))
            if (result) {
                ctx.updateContext(result)
            }
        }else{

            const result = await dispatch(checkVerify(authState.phone,code))
            if (result) {
                ctx.updateContext(result)
            }
        }
    }
    async function resendCode() {
        const result = await dispatch(resendCodeAction(authState.phone))
        if (result) {
            dispatch(onChangeAuth('time',60));
            notification.success({
                message: "",
                description: result.message,
                placement: 'bottomLeft',
            });
        
        }
    }
    return {
        formOtp, finish,resendCode
    }

}
export default OtpLogic;